import * as React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { RouteComponentProvider } from '@employee-experience/common/lib/RouteComponentProvider';
import { Loading } from './Shared/Loading/Loading';

/*eslint no-warning-comments: [2, { "terms": ["todo", "fixme", "any other term"], "location": "anywhere" }]*/
export function Routes(): React.ReactElement {
    return (
        <Switch>
            <Redirect exact from="/" to="/tar" />
            <RouteComponentProvider
                key="1"
                path="/tar"
                config={{
                    // @ts-ignore
                    script: `/bundles/tar.js?v${window.REACT_APP_TAR_VERSION}`,
                    name: 'TAR'
                }}
                renderPlaceholder={(): React.ReactElement => <Loading label={'Time and Absence'} />}
            />
            <RouteComponentProvider
                key="2"
                exact={true}
                path="/reports"
                config={{
                    // @ts-ignore
                    script: `/bundles/tar.js?v${window.REACT_APP_TAR_VERSION}`,
                    name: 'TAR'
                }}
                renderPlaceholder={(): React.ReactElement => <Loading label={'Reporting'} />}
            />
            <RouteComponentProvider
                key="3"
                exact={true}
                path="/administration"
                config={{
                    // @ts-ignore
                    script: `/bundles/tar.js?v${window.REACT_APP_TAR_VERSION}`,
                    name: 'TAR'
                }}
                renderPlaceholder={(): React.ReactElement => <Loading label={'Administration'} />}
            />
            {/* TODO: Hide bulk file upload until post March go-live */}
            {/* <RouteComponentProvider
                key="4"
                exact={true}
                path="/bulktimeupload"
                config={{
                    // @ts-ignore
                    script: `/bundles/tar.js?v${window.REACT_APP_TAR_VERSION}`,
                    name: 'TAR'
                }}
                renderPlaceholder={(): React.ReactElement => <Loading label={'Bulk Time Upload'} />}
            /> */}
            <RouteComponentProvider
                key="5"
                exact={true}
                path="/bulktimeentry"
                config={{
                    // @ts-ignore
                    script: `/bundles/tar.js?v${window.REACT_APP_TAR_VERSION}`,
                    name: 'TAR'
                }}
                renderPlaceholder={(): React.ReactElement => <Loading label={'Bulk Time Entry'} />}
            />

            <RouteComponentProvider
                key="6"
                exact={true}
                path="/splashpage"
                config={{
                    // @ts-ignore
                    script: `/bundles/tar.js?v${window.REACT_APP_TAR_VERSION}`,
                    name: 'TAR'
                }}
                renderPlaceholder={(): React.ReactElement => <Loading label={'Splash Page'} />}
            />
        </Switch>
    );
}
